import { render, staticRenderFns } from "./WizardTabs.vue?vue&type=template&id=9dff33bc&"
import script from "./WizardTabs.vue?vue&type=script&lang=js&"
export * from "./WizardTabs.vue?vue&type=script&lang=js&"
import style0 from "./WizardTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VTabItem})
